"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var drillDown_1 = tslib_1.__importDefault(require("./drillDown"));
exports.INTERACTION_MAP = {
    drilldown: drillDown_1.default,
};
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/g2plot/lib/plots/treemap/interaction/index.js
// module id = 990
// module chunks = 37